import { render, staticRenderFns } from "./InvestmentEstimate.vue?vue&type=template&id=0089f65e&scoped=true"
import script from "./InvestmentEstimate.vue?vue&type=script&lang=js"
export * from "./InvestmentEstimate.vue?vue&type=script&lang=js"
import style0 from "./InvestmentEstimate.vue?vue&type=style&index=0&id=0089f65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0089f65e",
  null
  
)

export default component.exports